import { render, staticRenderFns } from "./HeaderIcon.vue?vue&type=template&id=83778b40&scoped=true"
import script from "./HeaderIcon.vue?vue&type=script&lang=ts"
export * from "./HeaderIcon.vue?vue&type=script&lang=ts"
import style0 from "./HeaderIcon.vue?vue&type=style&index=0&id=83778b40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83778b40",
  null
  
)

export default component.exports